import Image from "next/image";
import { Radio } from "antd";

import MaleIcon from "~/public/static/icons/male.svg";
import FemaleIcon from "~/public/static/icons/female.svg";
import OtherIcon from "~/public/static/icons/other.svg";

const OPTIONS = [
  { value: "male", label: "男", icon: MaleIcon },
  { value: "female", label: "女", icon: FemaleIcon },
  { value: "other", label: "其他", icon: OtherIcon },
];

const GenderRadio = (props) => (
  <Radio.Group
    {...props}
    buttonStyle="solid"
    className="radio-gender"
  >
    {OPTIONS.map(({ value, label, icon }) => (
      <Radio.Button
        key={value}
        value={value}
      >
        <div className="gender-icon">
          <Image
            src={icon}
            width={26}
            height={26}
            alt={label}
          />
          {label}
        </div>
      </Radio.Button>
    ))}
  </Radio.Group>
);

export default GenderRadio;
